import React, {useState} from 'react';
import {message, Modal, Tag, Upload, UploadFile} from 'antd';
import {getOSSClient} from '@/utils/ossClient';
import {useAuth0} from '@auth0/auth0-react';
import {LuFileAudio2} from 'react-icons/lu';
import {ERROR_MESSAGES, FILE_CONSTANTS, STATUS_MESSAGES, SUCCESS_MESSAGES} from '@/constants/messages';
import {handleError, handleSuccess} from '@/utils/helpers';
import {processAudio} from '@/services/api';
import {getSLSClient, sendMessage} from "@/utils/slsClient";
import audioUpload from "@/pages/Index/static/audioUpload.png";
import { useSnapshot } from 'valtio/react';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';


// @ts-ignore
const AudioParser = ({ fList,setA2tNotice, fileChange,setData }) => {
  const [parsedContent, setParsedContent] = useState<Record<string, string>>({  });
  // 只使用 Supabase 认证状态
  const supabaseAuth = useSnapshot(supabaseAuthStore);
  const isNotLogin = !supabaseAuth.isLoading && !supabaseAuth.isAuthenticated && supabaseAuth.user === undefined;
  const [isLoad, setIsLoad] = useState(false);

  const customRequest = async ({ file, onProgress, onSuccess, onError }) => {
    try {
      setIsLoad(true);
      const client = await getOSSClient();

      // 编码处理文件名
      const oriName = file.name;
      const encodedName =  encodeURIComponent(oriName);
      const filePathWithName = `audio/${oriName}`;

      const audio = new Audio(URL.createObjectURL(file));
      await new Promise((resolve) => audio.onloadedmetadata = resolve);
      const duration = audio.duration; // 获取时长（秒）(double)

      console.log(39,encodedName, file,duration)
      // encodedName = "test.wav"

      // const fileName = `audio/${Date.now()}_${file.name}`;

      sendMessage("音频",oriName, "准备上传");

      setA2tNotice(STATUS_MESSAGES.UPLOADING)
      const result = await client.multipartUpload(filePathWithName, file, {
        progress: (percentage) => {
          const percent = Math.round(percentage * 100);
          // setUploadProgress(prev => ({...prev, [encodedName]: percent}));
          onProgress({ percent }, file);
        },
        partSize: FILE_CONSTANTS.PART_SIZE,
        meta: {
          // originalName: file.name,
          originalName: encodedName,
          type: file.type
        }
      });
      setA2tNotice(STATUS_MESSAGES.TRANSCRIBING)
      sendMessage("音频",oriName, "准备转录");


      // 发送 GET 请求
      try {
        const response = await processAudio(filePathWithName);
        console.log(62,response.data);
        if (response.data.success) {
          parsedContent[oriName] = response.data.data;
          setData(parsedContent)
          setA2tNotice(STATUS_MESSAGES.TRANSCRIPTION_COMPLETE);
          onSuccess(result, file);
          handleSuccess(SUCCESS_MESSAGES.TRANSCRIPTION_SUCCESS);
        } else {
          handleError(new Error(response.data.data.message), ERROR_MESSAGES.TRANSCRIPTION_ERROR);
          setA2tNotice(STATUS_MESSAGES.TRANSCRIPTION_ERROR);
          handleError(null, `${file.name} ${ERROR_MESSAGES.TRANSCRIPTION_PROCESS_ERROR}`);
        }
      } catch (apiError) {
        handleError(apiError, ERROR_MESSAGES.TRANSCRIPTION_ERROR);
        setA2tNotice(STATUS_MESSAGES.TRANSCRIPTION_ERROR);
        handleError(null, `${file.name} ${ERROR_MESSAGES.TRANSCRIPTION_PROCESS_ERROR}`);
      }

    } catch (error) {
      sendMessage("音频","处理出错"+file.name, error.message);
      handleError(error, `${file.name} ${ERROR_MESSAGES.UPLOAD_ERROR}: ${error.message}`);
      onError(error);
    }finally {
      setIsLoad(false);
    }
  };

    return (
      <div>
        <Upload
          // showUploadList={false}
          name="file"
          // multiple={false}
          accept=".wav,.m4a,.aac,.mp3,.ogg"
          beforeUpload={(file) => {

            if(isNotLogin){
              handleError(null,`未登录不支持语音转录`);
              return false;
            }

            // 文件大小限制（50MB）
            const maxSize = 2*1024 * 1024 * 1024;
            if (file.size > maxSize) {
              handleError(null,'文件大小不能超过2GB');
              return false;
            }
            return true;
          }}
          fileList={fList}
          customRequest={customRequest} // 覆盖默认上传行为
          onRemove={false}

          showUploadList={false}

          iconRender={()=><Tag color="cyan-inverse">音频</Tag>}
          maxCount={1}
          onChange={info => {
            console.log("audio file change",info);
            fileChange(info);
          }}
          disabled={isLoad}
        >

            {/*<LuFileAudio2*/}
            {/*    className="text-2xl text-[#4B5563] object-contain font-thin transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-110 hover:cursor-pointer"*/}
            {/*/>*/}
          <img
            src={audioUpload}
            className="w-5 h-5
            object-contain font-thin transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-110 hover:cursor-pointer
            "
            style={{ opacity: 0.8 }}
          />

        </Upload>
      </div>
    );
  }
;

export default AudioParser;